export const DOCUMENT_SOURCE_SLUGS = Object.freeze({
  ATTACHMENTS: 'attachments',
  FORM_UPLOADS: 'form_uploads'
});

export const DOCUMENT_PARENT_TABLES = Object.freeze({
  USER_GROUPS_PERIODS: 'user_groups_periods',
  FORM_SUBMISSIONS: 'form_submissions'
});

export const FORM_UPLOAD_CATEGORY = 'form_response';
